export default "__VITE_ASSET__CPDSAHzB__"